import React from "react";
import styles from "./virtualTourPopup.module.scss";

const VirtualTourPopup = ({ isOpen, onClose, virtualTourUrl }) => {
  if (!isOpen) return null;

  return (
    <div className={styles.popupOverlay}>
     
      <div className={styles.popupContent}>
      <button className={styles.closeButton} onClick={onClose}>
      <svg xmlns="http://www.w3.org/2000/svg" width="37" height="37" viewBox="0 0 37 37" fill="none">
            <path d="M1 35.5L35.5 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M35.5 35.5L1 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
        <div className={styles.virtualTourContainer}>
          <iframe
            src={virtualTourUrl}
            title="Virtual Tour"
            className={styles.virtualTourFrame}
            allowFullScreen
          />
        </div>
      </div>
    </div>
  );
};

export default VirtualTourPopup; 